export interface RecordContributionPreferences {
  addAnother: boolean;
  /** Last fund chosen in the record-offering dialog. */
  lastFundId: string | null;
}

const DEFAULT_PREFERENCES: RecordContributionPreferences = {
  addAnother: false,
  lastFundId: null,
};

function getPreferencesStorageKey(churchId?: string) {
  return churchId
    ? `giving-record-contribution-preferences:${churchId}`
    : 'giving-record-contribution-preferences';
}

export function loadRecordContributionPreferences(
  churchId?: string,
): RecordContributionPreferences {
  if (typeof window === 'undefined') {
    return DEFAULT_PREFERENCES;
  }

  try {
    const raw = window.localStorage.getItem(getPreferencesStorageKey(churchId));
    if (!raw) {
      return DEFAULT_PREFERENCES;
    }

    const parsed = JSON.parse(raw) as Partial<RecordContributionPreferences>;
    return {
      addAnother: parsed.addAnother === true,
      lastFundId: typeof parsed.lastFundId === 'string' ? parsed.lastFundId : null,
    };
  } catch {
    return DEFAULT_PREFERENCES;
  }
}

export function persistRecordContributionPreferences(
  churchId: string | undefined,
  preferences: RecordContributionPreferences,
) {
  if (typeof window === 'undefined') {
    return;
  }

  try {
    window.localStorage.setItem(
      getPreferencesStorageKey(churchId),
      JSON.stringify(preferences),
    );
  } catch {
    // Ignore storage failures and fall back to the in-memory state for this session.
  }
}
